import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { assertNever } from '../utils/assert-never';
import { AbortedBeaconError, BeaconErrorType, UnknownBeaconError, NetworkNotSupportedBeaconError, NoAddressBeaconError, NoPrivateKeyBeaconError, NotGrantedBeaconError, ParametersInvalidBeaconError, TooManyOperationsBeaconError, TransactionInvalidBeaconError, SignatureTypeNotSupportedBeaconError, BroadcastBeaconError // EncryptionTypeNotSupportedBeaconError
} from '..';
/**
 * @category Error
 */

export var BeaconError = /*#__PURE__*/function () {
  function BeaconError(errorType, message) {
    _classCallCheck(this, BeaconError);

    this.name = 'BeaconError';
    this.title = 'Error'; // Visible in the UI

    this.message = "[".concat(errorType, "]:").concat(message);
    this.description = message;
  }

  _createClass(BeaconError, [{
    key: "fullDescription",
    get: function get() {
      return this.description;
    }
  }], [{
    key: "getError",
    value: function getError(errorType, errorData) {
      switch (errorType) {
        case BeaconErrorType.BROADCAST_ERROR:
          return new BroadcastBeaconError();

        case BeaconErrorType.NETWORK_NOT_SUPPORTED:
          return new NetworkNotSupportedBeaconError();

        case BeaconErrorType.NO_ADDRESS_ERROR:
          return new NoAddressBeaconError();

        case BeaconErrorType.NO_PRIVATE_KEY_FOUND_ERROR:
          return new NoPrivateKeyBeaconError();

        case BeaconErrorType.NOT_GRANTED_ERROR:
          return new NotGrantedBeaconError();

        case BeaconErrorType.PARAMETERS_INVALID_ERROR:
          return new ParametersInvalidBeaconError();

        case BeaconErrorType.TOO_MANY_OPERATIONS:
          return new TooManyOperationsBeaconError();

        case BeaconErrorType.TRANSACTION_INVALID_ERROR:
          return new TransactionInvalidBeaconError(errorData);

        case BeaconErrorType.SIGNATURE_TYPE_NOT_SUPPORTED:
          return new SignatureTypeNotSupportedBeaconError();
        // case BeaconErrorType.ENCRYPTION_TYPE_NOT_SUPPORTED:
        //   return new EncryptionTypeNotSupportedBeaconError()

        case BeaconErrorType.ABORTED_ERROR:
          return new AbortedBeaconError();

        case BeaconErrorType.UNKNOWN_ERROR:
          return new UnknownBeaconError();

        default:
          assertNever(errorType);
      }
    }
  }]);

  return BeaconError;
}();